import PropTypes from 'prop-types';
import advertisersStrings from 'modules/advertisers/strings';

import { Wrapper, SearchBarWrapper, SearchBar, SearchBarIcon } from './AdvertisersFilter.style';

const AdvertisersFilter = ({ searchQuery, handleSearchBarInputChange }) => (
  <Wrapper>
    <SearchBarWrapper>
      <SearchBarIcon />
      <SearchBar
        placeholder={advertisersStrings.advertisersFilter.searchBarPlaceholder}
        value={searchQuery}
        onChange={handleSearchBarInputChange}
      />
    </SearchBarWrapper>
  </Wrapper>
);
AdvertisersFilter.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
};

export default AdvertisersFilter;
